'use strict';

// Import Libraries
import React from 'react';
// Import JS Modules
import classNames          from 'classnames';

import FileThumbnail       from './file-thumbnail';
import LazyThumbnail       from './lazy-thumbnail';
import UrlThumbnail        from './url-thumbnail';
import AlbumCoverThumbnail from './album-cover-thumbnail';

const Thumbnails = props => {
  const files = props.files || [];

  return (
    <div className={classNames('thumbnails', props.classes)}>
      {files.map(renderFile, this)}
    </div>
  );


  function renderFile(file, i) {
    let thumbnailType;

    switch (file.source) {
      case 'url':
        thumbnailType = UrlThumbnail;
        break;
      case 'album':
        thumbnailType = AlbumCoverThumbnail;
        break;
      case 'footer':
      default:
        thumbnailType = FileThumbnail;
        break;
    }

    return (
      <LazyThumbnail
        file={file}
        key={'' + i + (file.name || file.url)}
        selected={props.isSelected ? props.isSelected(file) : false}
        thumbnailType={thumbnailType}
        withOrientation={props.withOrientation}
        onImagePreviewError={props.onImagePreviewError}
        onErrorIconClick={props.onErrorIconClick}
        onRemoveThumbnail={props.onRemoveThumbnail}
        onSelect={props.handleSelect}
        onUnSelect={props.handleUnSelect}
        displayCaption={props.displayCaption}
      />
    );
  }
};

export default Thumbnails;
